module.exports = __webpack_public_path__ + "img/gi.gi89adf2b.svg";